import { useMutation } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ampli } from '../../../../ampli';
import { postSignUp } from '../../../../api/auth/mutations/postSignUp';
import { usePopup } from '../../../popup/usePopup';

export const usePostSignUpMutation = () => {
  const navigate = useNavigate();
  const Popup = usePopup();
  const location = useLocation();

  return useMutation(postSignUp, {
    onSuccess: (data) => {
      ReactGA.event('pvm_sign_up', { category: 'pvm', action: 'pvm_sign_up' });
      ampli.pvmSignUp();
      sessionStorage.removeItem('@signUpToken');
      localStorage.setItem('@accessToken', `${data.accessToken ?? ''}`);
      navigate('/after-join', { replace: true });
    },
    onError: (error: Error) => {
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '회원가입 실패',
        '에러가 발생한 URL': location.pathname,
      });
      navigate('/oauth/login', { replace: true });
      Popup.toast('회원가입에 실패하였습니다.');
    },
  });
};
